import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

const AuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("Autenticando con Microsoft...");

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get("token");
      const userId = searchParams.get("user_id");
      const error = searchParams.get("error");

      if (error) {
        setStatus("error");
        setMessage("Error de autenticación: " + error);
        setTimeout(() => navigate("/login"), 3000);
        return;
      }

      if (!token) {
        setStatus("error");
        setMessage("No se recibió token de autenticación");
        setTimeout(() => navigate("/login"), 3000);
        return;
      }

      try {
        // Use the token to set auth state
        const result = await loginWithToken(token);
        
        if (result.success) {
          setStatus("success");
          setMessage("¡Autenticación exitosa! Redirigiendo...");
          setTimeout(() => navigate("/dashboard"), 1500);
        } else {
          setStatus("error");
          setMessage(result.error || "Error al procesar la autenticación");
          setTimeout(() => navigate("/login"), 3000);
        }
      } catch (err) {
        console.error("Auth callback error:", err);
        setStatus("error");
        setMessage("Error inesperado durante la autenticación");
        setTimeout(() => navigate("/login"), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, loginWithToken]);

  return (
    <div className="min-h-screen bg-[#04042C] flex items-center justify-center p-4">
      <div className="text-center">
        {status === "loading" && (
          <>
            <Loader2 className="h-12 w-12 text-[#42E695] animate-spin mx-auto mb-4" />
            <h2 className="text-xl text-white font-semibold">{message}</h2>
            <p className="text-slate-400 mt-2">Por favor espera...</p>
          </>
        )}
        
        {status === "success" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-[#42E695] mx-auto mb-4" />
            <h2 className="text-xl text-white font-semibold">{message}</h2>
          </>
        )}
        
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl text-white font-semibold">{message}</h2>
            <p className="text-slate-400 mt-2">Redirigiendo al login...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallbackPage;
